import { leafletLayer } from 'protomaps-leaflet'
import { ReactNode } from 'react'

export const MAPA_TILES_URL = '/api/mapaTiles'

export const BRASIL_MAP_CENTER: [number, number] = [-51.9253, -14.235]

export const BRASIL_MAP_MAX_BOUNDS: [[number, number], [number, number]] = [
  [-76, -35],
  [-32, 7],
]

export type LeafletLayerUrl = NonNullable<Parameters<typeof leafletLayer>[0]>['url']

export const MAP_MARKER_SIZE: [number, number] = [28, 34]

export interface MapMarkerModel {
  id: string
  coordinates: [number, number]
  content: ReactNode
  size?: [number, number]
  anchor?: [number, number]
}

export const EMPTY_MAP_MARKERS: MapMarkerModel[] = []
